module.exports = __webpack_public_path__ + "img/saas-paas.24d3b704.svg";